import Vue from 'vue';
import Component from 'vue-class-component';

/**
 * Provide base functionality for start and stop loading
 */
@Component
export default class LoadingMixin extends Vue {
  loadingState = false;

  get isLoading() {
    return this.loadingState;
  }

  loadingStart() {
    this.loadingState = true;
  }

  loadingStop() {
    this.loadingState = false;
  }
}



// WEBPACK FOOTER //
// ./src/lib/mixins/loading-mixin.js